export const RoutesLookup = {
  Home: '/',
  Services: '/services',
  Booking: '/booking',
  Contact: '/contact',
  GeneralInfo: '/info',
  Policies: '/policies',
};
